import axios from 'axios'

const portal = axios.create({
  baseURL: process.env.baseUrlPortal,
  withCredentials: false,
  timeout: 30000
})

export default portal
